import { z } from 'zod';

/**
 * work-024 C (ADR-0012): схемы апелляции на общий бан.
 *
 * Анонимность (CANON B4/SP4): fingerprint в body НЕ принимаем —
 * резолвится серверно из tgUser.id + SERVER_SALT.
 */

// ── Подача апелляции (POST /senders/appeal) ──────────────────────────────────

export const CreateAppealBody = z
  .object({
    message: z.string().trim().min(1).max(500).optional(),
  })
  .strict();

export type CreateAppealBodyType = z.infer<typeof CreateAppealBody>;

export const CreateAppealResponse = z
  .object({
    ok: z.literal(true),
  })
  .strict();

export type CreateAppealResponseType = z.infer<typeof CreateAppealResponse>;

// ── Admin: ревью (POST /admin/appeals/review) ─────────────────────────────────

export const AdminAppealReviewBody = z
  .object({
    appealId: z.string().min(1),
  })
  .strict();

export type AdminAppealReviewBodyType = z.infer<typeof AdminAppealReviewBody>;

// ── Admin: решение (POST /admin/appeals/decide) ───────────────────────────────

export const AdminAppealDecideBody = z
  .object({
    appealId: z.string().min(1),
    decision: z.enum(['approve', 'reject']),
  })
  .strict();

export type AdminAppealDecideBodyType = z.infer<typeof AdminAppealDecideBody>;

export const AdminAppealDecideResponse = z
  .object({
    ok: z.literal(true),
    decision: z.enum(['approve', 'reject']),
  })
  .strict();

export type AdminAppealDecideResponseType = z.infer<typeof AdminAppealDecideResponse>;
